<template>
  <div ref="NumCJBar" class="NumCJ"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    barName: {
      type: Array,
      default: () => {
        return [];
      },
    },
    valMaxNum: {
      type: Number,
      default: 13,
    },
    typeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    barVal1: {
      type: Array,
      default: () => {
        return [];
      },
    },

    blo: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  watch: {
    barVal1: {
      handler(newss, old) {
        this.getEcharts();
      },
      immediate: false,
    },
    barName: {
      handler(newss, old) {
        this.getEcharts();
      },
      immediate: false,
    },
  },
  methods: {
    getEcharts() {
      var myChart = echarts.init(this.$refs.NumCJBar);
      var option;
      let dataZoomStr = [];
      var that = this;
      if (that.barVal1.length > that.valMaxNum) {
        dataZoomStr = [
          {
            type: "slider",
            show: true, //显示滚动条
            zoomLock: true, //锁定滚动条缩放，（固定滚动条长度）
            xAxisIndex: [0],
            left: "5%", //离左边的百分比距离
            bottom: "2%",
            backgroundColor: "#055266",
            borderColor: "#055266 ", //边框和背景颜色一致，（因为无法做到无边框，只能跟随页面背景）
            height: 0, //滚动条高度
            showDetail: false, //关闭：拖拽时候显示详细数值信息。
            fillerColor: "#0194B3", //滚动条颜色
            moveHandleStyle: {
              color: "#0194B3",
            },
            handleSize: "100%", //矢量尺寸占比
            handleStyle: {
              borderWidth: 0,
              color: "#0194B3",
            },

            start:
              100 -
              Number.parseInt((that.valMaxNum * 100) / that.barVal1.length), //初始化滚动条开始位置
            end: 100, //初始化滚动条结束位置
           
            // end: Number.parseInt((that.valMaxNum * 100) / that.barVal1.length), //初始化滚动条结束位置
            showDataShadow: false, //屏蔽折线图，true为显示折线图
          },
        ];
      }
      option = {
        tooltip: {
          show: true, //设置是否显示提示框
          trigger: "axis",
          textStyle: {
            color: "#1CC1F6",
          },
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "5%",
          top: "10%",
          containLabel: true,
        },
        // dataZoom: dataZoomStr,
        // //上方每条先备注
        // legend: {
        //   data: that.typeList,
        //   left: 20,
        //   top: 0,
        //   // type: "scroll",
        //   textStyle: {
        //     fontSize: 10,
        //     color: "#999999",
        //   },
        // },
        xAxis: {
          type: "category",
          data: that.barName,
          boundaryGap: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#999999", //底部文字色
            },
          },
          axisLabel: {
            interval: 0,
            show: true,
            showMaxLabel: false,
          },
          // nameTextStyle: {
          //   color: "#000",
          // },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "transparent", //竖向线条色
            },
          },
          offset: 5,
          axisTick: {
            show: false,
            length: 9,
            alignWithLabel: true,
            lineStyle: {
              color: "#000",
            },
          },
        },
        yAxis: {
          type: "value",
          // min: that.blo == 1 ? 0 : null,
          // max: that.blo == 1 ? 500 : null,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#26304e",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#999999",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#999999",
          },
        },
        series: [
          {
            smooth: true, //线段平滑设置
            symbol: "circle", //标记位置的图形
            symbolSize: 5,
            data: that.barVal1,
            showSymbol: true,
            type: "line",
            // stack: "Total",
            name: that.typeList[0],
            itemStyle: {
              normal: {
                color: "#409eff  ",
              },
            },
            //区域填充设置
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 1, color: "RGBA(23, 70, 85, 0)" },
                  { offset: 0, color: "RGBA(23, 70, 85, 0)" },
                ]),
              },
            },
            // 线条设置
            lineStyle: {
              color: "#409eff  ",
              width: 1,
              type: "solid",
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
  created() {
    this.$nextTick(() => {
      this.getEcharts();
    });
  },
};
</script>

<style lang="less" scoped>
.NumCJ {
  width: 100%;
  height: 100%;
}
</style>
